import { Injectable } from '@angular/core';
import {
  AddedNote,
  DeletedNote,
  EditedNote,
  INotesService,
} from '@bcl/design-system';
import { EMPTY } from 'rxjs';
import { NotesApiService } from './notes-api.service';
import { ParentContext } from './notes.model';

@Injectable({ providedIn: 'root' })
export class NotesService implements INotesService {
  private parentContext?: ParentContext;

  constructor(private api: NotesApiService) {}

  public setParentContext(parentContext: ParentContext): void {
    this.parentContext = parentContext;
  }

  public addNote(note: AddedNote) {
    if (!this.parentContext) {
      return EMPTY;
    }

    return this.api.addNote({
      ...note,
      parentID: this.parentContext.parentId,
      parentObject: this.parentContext.parentObject,
    });
  }

  public updateNote(note: EditedNote) {
    return this.api.editNote(note);
  }

  public deleteNote(note: DeletedNote) {
    return this.api.deleteNote(note.id);
  }
}
